(() => {
  if (window.cd13ProfileTechnicalFiltersReady) return;
  window.cd13ProfileTechnicalFiltersReady = true;

  const normalise = (value = '') => value.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().trim();
  const addOption = (select, value, label) => {
    const option = document.createElement('option');
    option.value = value;
    option.textContent = label;
    select.appendChild(option);
  };
  const productHandle = (card) => {
    if (card.dataset.profileHandle) return card.dataset.profileHandle;
    const link = card.querySelector('[data-profile-link]');
    if (!link) return '';
    try {
      const parts = new URL(link.href, window.location.origin).pathname.split('/').filter(Boolean);
      return parts[parts.length - 1] || '';
    } catch (_) {
      return '';
    }
  };

  const init = async (section) => {
    const cards = [...section.querySelectorAll('[data-profile-card]')];
    const search = section.querySelector('[data-profile-search]');
    const majorSelect = section.querySelector('[data-profile-major]');
    const secondarySelect = section.querySelector('[data-profile-section]');
    const typeSelect = section.querySelector('[data-profile-feature]');
    const reset = section.querySelector('[data-profile-reset]');
    const resultCount = section.querySelector('[data-profile-result-count]');
    const resultHint = section.querySelector('[data-profile-result-hint]');
    const noResult = section.querySelector('[data-profile-no-result]');

    if (!cards.length || !search || !majorSelect || !secondarySelect || !typeSelect) return;

    const majorLabel = section.querySelector(`label[for='${majorSelect.id}']`);
    const secondaryLabel = section.querySelector(`label[for='${secondarySelect.id}']`);
    const typeLabel = section.querySelector(`label[for='${typeSelect.id}']`);
    if (majorLabel) majorLabel.textContent = '1. Section principale';
    if (secondaryLabel) secondaryLabel.textContent = '2. Section secondaire';
    if (typeLabel) typeLabel.textContent = '3. Type de profilé';
    majorSelect.setAttribute('aria-label', 'Choisir la section principale');
    secondarySelect.setAttribute('aria-label', 'Choisir la section secondaire');
    typeSelect.setAttribute('aria-label', 'Choisir le type de profilé');

    [...majorSelect.options].forEach((option) => {
      if (option.value === 'all') option.textContent = 'Toutes les sections principales';
    });
    [...secondarySelect.options].forEach((option) => {
      if (option.value === 'all') option.textContent = secondarySelect.disabled
        ? 'Choisir d’abord une section principale'
        : 'Toutes les sections secondaires';
    });

    const noResultText = noResult?.querySelector('span');
    if (noResultText) noResultText.textContent = 'Effacez un critère ou essayez une autre section principale.';

    const typeField = typeSelect.closest('.cd13-profile-finder__field');
    if (!typeField) return;

    let rainureSelect = section.querySelector('[data-profile-rainure]');
    if (!rainureSelect) {
      const field = document.createElement('div');
      const rainureId = typeSelect.id.replace('ProfileFeature-', 'ProfileRainure-');
      field.className = 'cd13-profile-finder__field';
      field.innerHTML = `<label for='${rainureId}'>4. Rainure</label><select id='${rainureId}' data-profile-rainure aria-label='Choisir la rainure'></select>`;
      typeField.insertAdjacentElement('afterend', field);
      rainureSelect = field.querySelector('[data-profile-rainure]');
    }
    if (!rainureSelect) return;

    typeSelect.innerHTML = '';
    addOption(typeSelect, 'all', 'Chargement des types…');
    typeSelect.disabled = true;
    rainureSelect.innerHTML = '';
    addOption(rainureSelect, 'all', 'Chargement des rainures…');
    rainureSelect.disabled = true;

    const productTypes = new Map();
    const variantRainures = new Map();
    const productRainures = new Map();

    try {
      let nextPage = '1';
      let pageGuard = 0;

      while (nextPage && pageGuard < 20) {
        pageGuard += 1;
        const endpoint = new URL(window.location.pathname, window.location.origin);
        endpoint.searchParams.set('view', 'profile-rainures');
        endpoint.searchParams.set('page', nextPage);

        const response = await fetch(endpoint.toString(), {
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const documentData = new DOMParser().parseFromString(await response.text(), 'text/html');
        const root = documentData.querySelector('[data-profile-rainure-map]');
        if (!root) throw new Error('Données techniques absentes');

        root.querySelectorAll('[data-profile-rainure-product]').forEach((productNode) => {
          const handle = productNode.dataset.profileRainureProduct || '';
          const profileType = (productNode.dataset.profileType || '').trim();
          const rainures = [];

          productTypes.set(handle, profileType);

          productNode.querySelectorAll('[data-profile-rainure-variant]').forEach((variantNode) => {
            const variantId = variantNode.dataset.profileRainureVariant || '';
            const rainure = (variantNode.dataset.rainure || '').trim();
            variantRainures.set(`${handle}:${variantId}`, rainure);
            if (rainure) rainures.push(rainure);
          });

          productRainures.set(handle, [...new Set(rainures)]);
        });

        nextPage = root.dataset.nextPage || '';
      }
    } catch (error) {
      console.warn('[CD13] Chargement des filtres techniques impossible.', error);
    }

    const typeLabels = new Map();
    [...productTypes.values()].filter(Boolean).forEach((value) => {
      const key = normalise(value);
      if (key && !typeLabels.has(key)) typeLabels.set(key, value);
    });
    const allTypes = [...typeLabels.entries()]
      .sort((a, b) => a[1].localeCompare(b[1], 'fr', { numeric: true, sensitivity: 'base' }));

    typeSelect.innerHTML = '';
    addOption(typeSelect, 'all', allTypes.length ? 'Tous les types de profilé' : 'Types indisponibles');
    allTypes.forEach(([value, label]) => addOption(typeSelect, value, label));
    typeSelect.disabled = allTypes.length === 0;

    const allRainures = [...new Set([...variantRainures.values()].filter(Boolean))]
      .sort((a, b) => a.localeCompare(b, 'fr', { numeric: true, sensitivity: 'base' }));

    rainureSelect.innerHTML = '';
    addOption(rainureSelect, 'all', allRainures.length ? 'Toutes les rainures' : 'Rainures indisponibles');
    allRainures.forEach((value) => addOption(rainureSelect, value, value));
    rainureSelect.disabled = allRainures.length === 0;

    cards.forEach((card) => {
      const handle = productHandle(card);
      const profileType = productTypes.get(handle) || '';
      card._cd13ProfileType = profileType;
      card._cd13ProfileTypeNormalised = normalise(profileType);
      card._cd13Rainures = productRainures.get(handle) || [];
      card._cd13NormalisedRainures = card._cd13Rainures.map(normalise);

      if (profileType && typeof card._normalisedProduct === 'string') {
        card._normalisedProduct = normalise(`${card._normalisedProduct} ${profileType}`);
      }

      const select = card.querySelector('[data-profile-variant-select]');
      if (!select) return;
      [...select.options].forEach((option) => {
        const rainure = variantRainures.get(`${handle}:${option.value}`) || '';
        option.dataset.cd13Rainure = rainure;
        option.dataset.cd13RainureNormalised = normalise(rainure);
      });
    });

    let refreshingBase = false;

    const applyTechnicalFilters = () => {
      const selectedType = typeSelect.value;
      const selectedRainureRaw = rainureSelect.value;
      const selectedRainure = normalise(selectedRainureRaw);
      let visibleCards = 0;
      let visibleVariants = 0;

      cards.forEach((card) => {
        const baseCardVisible = !card.hidden;
        const typeMatches = selectedType === 'all' || card._cd13ProfileTypeNormalised === selectedType;
        const select = card.querySelector('[data-profile-variant-select]');
        let matches = [];

        if (select) {
          [...select.options].forEach((option) => {
            const baseMatch = !option.disabled && !option.hidden;
            const rainureMatches = selectedRainureRaw === 'all' || option.dataset.cd13RainureNormalised === selectedRainure;
            const match = baseMatch && typeMatches && rainureMatches;
            option.disabled = !match;
            option.hidden = !match;
            if (match) matches.push(option);
          });
        } else {
          const rainureMatches = selectedRainureRaw === 'all' || card._cd13NormalisedRainures.includes(selectedRainure);
          if (baseCardVisible && typeMatches && rainureMatches) matches = [null];
        }

        card.hidden = !baseCardVisible || matches.length === 0;
        if (!card.hidden) {
          visibleCards += 1;
          visibleVariants += matches.length;
          if (select && select.selectedOptions[0]?.disabled && matches[0]) {
            select.value = matches[0].value;
            select.dispatchEvent(new Event('change', { bubbles: false }));
          }
        }
      });

      if (noResult) noResult.hidden = visibleCards !== 0;
      if (resultCount) {
        resultCount.textContent = `${visibleCards} famille${visibleCards > 1 ? 's' : ''} · ${visibleVariants} variante${visibleVariants > 1 ? 's' : ''}`;
      }
      if (resultHint) {
        const parts = [resultHint.dataset.cd13BaseHint || 'Tous les profilés disponibles'];
        if (selectedType !== 'all') parts.push(`Type ${typeLabels.get(selectedType) || selectedType}`);
        if (selectedRainureRaw !== 'all') parts.push(`Rainure ${selectedRainureRaw}`);
        resultHint.textContent = parts.join(' · ');
      }
      if (reset && (selectedType !== 'all' || selectedRainureRaw !== 'all')) reset.hidden = false;
    };

    const refreshBase = () => {
      const selectedType = typeSelect.value;
      refreshingBase = true;
      typeSelect.value = 'all';
      search.dispatchEvent(new Event('input', { bubbles: true }));
      typeSelect.value = selectedType;
      refreshingBase = false;

      if (resultHint) resultHint.dataset.cd13BaseHint = resultHint.textContent || 'Tous les profilés disponibles';
      applyTechnicalFilters();
    };

    typeSelect.addEventListener('change', refreshBase);
    rainureSelect.addEventListener('change', refreshBase);

    section.addEventListener('input', (event) => {
      if (refreshingBase || event.target === typeSelect || event.target === rainureSelect) return;
      setTimeout(refreshBase, 0);
    });

    section.addEventListener('change', (event) => {
      if (refreshingBase || event.target === typeSelect || event.target === rainureSelect) return;
      setTimeout(() => {
        [...secondarySelect.options].forEach((option) => {
          if (option.value === 'all') {
            option.textContent = secondarySelect.disabled
              ? 'Choisir d’abord une section principale'
              : 'Toutes les sections secondaires';
          }
        });
        refreshBase();
      }, 0);
    });

    reset?.addEventListener('click', () => {
      typeSelect.value = 'all';
      rainureSelect.value = 'all';
      setTimeout(refreshBase, 0);
    }, true);

    refreshBase();
  };

  document.querySelectorAll('[data-profile-collection]').forEach((section) => {
    if (section.dataset.totalCount && section.querySelectorAll('[data-profile-card]').length >= Number(section.dataset.totalCount)) {
      init(section);
    } else {
      section.addEventListener('cd13:profile-cards-ready', () => init(section), { once: true });
    }
  });
})();
